import { ProductTypeEnum } from '@ztechapps/common.contract'

export const ProductType = {
  inventory: {
    value: ProductTypeEnum.Inventory,
    label: 'Inventory item',
    description:
      'It tracks and manage inventory count. Included on Packing slip, Case label and Internation shipping items if has tariff code.',
  },
  nonInventoryItem: {
    value: ProductTypeEnum.NonInventory,
    label: 'Non-Inventory item',
    description:
      'It does no track and manage inventory count. Included on Packing slip, Case label and Internation shipping items if has tariff code.',
  },
  services: {
    value: ProductTypeEnum.Service,
    label: 'Service',
    description:
      'It does no track and manage inventory count. NOT Included on Packing slip, Case label and Internation shipping items.',
  },

  capitalEquipment: {
    value: ProductTypeEnum.CapitalEquipment,
    label: 'Capital Equipment',
    description: 'This would usually be big ticket items like machining centers,  wire edm,  trucks,  and cars. ',
  },
  vendor: {
    value: ProductTypeEnum.Vendor,
    label: 'Vendor',
    description: 'Purchased items from vendors',
  },
}
